import { httpClient } from '@/services/http/httpClient'

export const unarchivePortfolioProject = async (projectId: string) => {
  await httpClient.put(`/projects/portfolio-projects/${projectId}/unarchive`)
}
